module.exports = "/templates/template.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/template.html
// module id = 473
// module chunks = 0